// Тип для состояния иконок
interface IconsState {
    icons: Record<string, any>
  }
  
  // Начальное состояние
  const state = (): IconsState => ({
    icons: {},
  })
  
  // Мутации
  const mutations = {
    SET_ICONS(state: IconsState, data: Record<string, any>): void {
      state.icons = data
    },
  }
  
  // Действия
  const actions = {
    loadIcons({ commit }: any): void {
      const cache: Record<string, any> = {}
      
      function importAll(r: any): void {
        r.keys().forEach((key: string) => {
          const fileName = key.substr(2, key.length - 6)
          cache[fileName] = r(key)
        })
      }
      
      const allSVG = require.context(
        '@/nms/components/media/svg/static/files',
        false,
        /\.svg$/,
      )
      
      importAll(allSVG)
      commit('SET_ICONS', cache)
    },
  }
  
  // Геттеры
  const getters = {
    getIconSVGSafe: (state: IconsState) => (name: string) => {
      return state.icons[name] || state.icons.file_not_found
    },
  
    getIconsNotLoaded: (state: IconsState): boolean => {
      return state.icons.file_not_found === undefined
    },
  }
  
  // Экспортируем модуль (как обычный JS объект)
  export default {
    state,
    mutations,
    actions,
    getters,
  }